module.exports = __webpack_public_path__ + "ifi1-4ed7caf6fe37034738f95708afbb0c3b.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/ifi1.png
// module id = qN56
// module chunks = client